export const SET_CLIENTS = 'clients/set';
export const ADD_CLIENT_TO_LIST = 'clients/add';
export const EDIT_CLIENT_IN_LIST = 'clients/edit';
export const DELETE_CLIENT_FROM_LIST = 'clients/delete';
export const CLEAR_CLIENTS = 'clients/clear';
export const GET_CLIENT_BY_ID = 'clients/get_by_id';
